import {formatSharpHour, getDaySchedule} from "./dateTimeHelpers";
import moment_tz from "moment-timezone";
import {getState} from "../state/getState";

export const isIntervalDisabled = (date, start, end, list = null) => {
    if (!list) {
        list = getState('bookingList')
    }

    const config = getState('config')
    const schedule = getDaySchedule(date)

    if (schedule.blocked) {
        return true
    }

    const scheduleStartMoment = moment_tz.tz(date + " " + formatSharpHour(schedule.start), config.timezone).utc().tz(config.timezone)
    const scheduleEndMoment = moment_tz.tz(date + " " + formatSharpHour(schedule.end), config.timezone).utc().tz(config.timezone)
    const startMoment = moment_tz.tz(date + " " + start, config.timezone).utc().tz(config.timezone)
    const endMoment = moment_tz.tz(date + " " + end, config.timezone).utc().tz(config.timezone)

    if (startMoment.isBefore(scheduleStartMoment) || endMoment.isAfter(scheduleEndMoment)) {
        return true
    }

    if (list) {
        const overlappingBooking = list.find( (booking, index) => {
            const bookingStartMoment = moment_tz.tz(booking.start, config.timezone).utc().tz(config.timezone)
            const bookingEndMoment = moment_tz.tz(booking.end, config.timezone).utc().tz(config.timezone)

            if (startMoment.isBefore(bookingEndMoment) && bookingStartMoment.isBefore(endMoment)) {
                return booking
            }
        })

        if (overlappingBooking) {
            return true
        }
    }

    return false
}